// @flow
import * as React from 'react'
import Field from './Field'

// Types
import type { RenderFunc, Props } from './Field'

/**
 * Little helper function to create a Field component with optimized
 * render updates.
 *
 * It forces the developer to not write any kind of
 * validation or normalization functions inside a render function.
 * Instead the dev have to provide such methods in options object
 * (second argument).
 *
 * It also limits the dev to not use any prop from outside of the Field.
 * Instead the dev have to provide any options as a separate prop `options`,
 * which is used to determine should the Field be updated or not using shallow
 * compare the old and new options objects.
 *
 * @param  {Function} render
 * @param  {Object} options
 * @return {React.ComponentType}
 */
const createField = (render: RenderFunc, options?: $Shape<Props>) => {
  const FieldWrapper = (props: any) => (
    <Field {...options} {...props} render={render} __optimizeUpdates />
  )
  FieldWrapper.defaultProps = Field.defaultProps
  return FieldWrapper
}

export default createField
